import "@/App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <main>
        <Home />
        <Rooms />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
